<nav *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
      </a>
    </li>
  </ul>
</nav>

<aside class="navbar-container d-flex content">
  <nav class="bookmark-wrapper d-flex align-items-center">
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>

    <li class="nav-item d-none d-lg-block"></li>
  </nav>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <li ngbDropdown class="nav-item dropdown-user">
      <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle
        id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
        <div class="user-nav d-sm-flex d-none">
          <span [ngClass]="currentUser?.superAdmin? 'font-weight-bolder':'user-name font-weight-bolder'">{{currentUser?.primeiroNome + " " + currentUser?.ultimoNome}}</span>
          <span *ngIf="!currentUser?.superAdmin" class="user-status">{{ currentUser?.cargoEmpresa }} {{currentUser?.areaNome }} -{{ currentUser?.empresaNome }}</span>
        </div>
        <figure class="avatar">
          <img *ngIf="!currentUser?.superAdmin && currentUser !== null" class="round"
            [src]="currentUser?.midiaCaminho | secure | async" alt="avatar" height="40" width="40" />
        </figure>
      </a>
      <nav ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <a ngbDropdownItem *ngIf="!currentUser?.superAdmin" [routerLink]="['/portal/home']"><span
            [data-feather]="'user'" [class]="'mr-50'"></span> Portal</a>
        <div *ngIf="!currentUser?.superAdmin" class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span> Logout</a>
      </nav>
    </li>
  </ul>
</aside>